<template>
    <v-menu
        open-on-hover
        top
        offset-y
    >
        <template #activator="{on}">
        <v-btn v-on="on" icon small>
            <v-icon>mdi-cogs</v-icon>
        </v-btn>
        </template>
        
        <v-card>
            <v-card-title>Built values</v-card-title>
            
            <v-simple-table>
            <template v-slot:default>
                <thead>
                <tr>
                    <th colspan="2"></th>
                    <th colspan="2" class="text-center cyan lighten-5">Head</th>
                    <th colspan="3" class="text-center green lighten-5">Shaft</th>
                </tr>
                <tr>
                    <th class="text-left">
                    Built date
                    </th>
                    <th class="text-left">
                    Builder
                    </th>
                    <th class="text-left cyan lighten-5">
                    Loft
                    </th>
                    <th class="text-left cyan lighten-5">
                    Lie
                    </th>
                    <th class="text-left green lighten-5">
                    Length
                    </th>
                    <th class="text-left green lighten-5">
                    CPM
                    </th>
                    <th class="text-left green lighten-5">
                    SW
                    </th>
                    <th>Comment</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{{built.created_at | formatDate}}</td>
                    <td>{{built.builder.displayName}}</td>
                    <td class="cyan lighten-5">{{built.headLoft}}</td>
                    <td class="cyan lighten-5">{{built.headLie}}</td>
                    <td class="green lighten-5">{{built.shaftLength}}</td>
                    <td class="green lighten-5">{{built.shaftCpm}}</td>
                    <td class="green lighten-5">{{built.shaftSW}}</td>
                    <td>{{built.comment}}</td>
                </tr>
                </tbody>
            </template>
            </v-simple-table>
        </v-card>
    </v-menu>
</template>

<script>
import moment from 'moment';
export default {
    props: {
        built: {
            type: Object,
            required: true
        }
    },
    filters:{
        formatDate (value) {
            if (!value) return '';
            return moment(value).format('DD/MM/YYYY, HH:mm:ss');
        }
    },
}
</script>

<style>

</style>